import gql from 'graphql-tag';
import hostContactDetailFragments from '../fragments/host-contact-detail.fragments';

const HOST_CONTACT_DETAIL_QUERY = gql`
    query hostContactForGuest($listingId: String!) {
        hostContactForGuest(listingId: $listingId) {
            ...HostContactDetailHostContactDetail
        }
    }
    ${hostContactDetailFragments.HostContactDetail}
`;

export default HOST_CONTACT_DETAIL_QUERY;
